import React from "react"
import { ColorModeProvider } from "./src/context/ColorModeProvider"
import { GlobalStyle } from "./src/Theme/GlobalStyle"

export const wrapRootElement = ({ element }) => (

  <ColorModeProvider>

    <GlobalStyle />

    {element}

  </ColorModeProvider>

)